import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
import { Container } from './Container';
import { Highlight, SectionHeading } from './SectionHeading';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-white py-14 sm:py-20 lg:py-28" data-id="element-40" data-mp="1glpt5qmtth74">
      <Container data-id="element-41" data-mp="24a91251yrryo">
        <SectionHeading eyebrow="Questions" title={<>
              Frequently asked <Highlight data-id="element-43" data-mp="289zz8tttlad8">questions</Highlight>
            </>} data-id="element-42" data-mp="249pvzoxewy22" />
        <div className="mx-auto max-w-[820px] space-y-3" data-id="element-44" data-mp="1uilfulw0375n">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.question} className="rounded-xl border border-line bg-cream" data-id="element-45" data-mp="2n8bx33sxip5z" data-mpi={i}>
                <h3 data-id="element-46" data-mp="2rys9ckl0k4qr">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex min-h-[56px] w-full items-center justify-between gap-4 px-4 py-4 text-left text-[15px] font-bold leading-snug text-navy sm:px-6 sm:py-5 sm:text-[17px]" data-id="element-47" data-mp="2rzagic97s3dg">
                    {faq.question}
                    <PlusIcon aria-hidden="true" className={`h-5 w-5 shrink-0 text-teal transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} data-id="element-48" data-mp="19safk220tnqb" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-49" data-mp="1xio7lsklvmkw">
                  {isOpen && <motion.div id={`faq-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-50" data-mp="1slxvfgbx9b4r">
                      <p className="px-4 pb-5 text-[14px] text-muted sm:px-6 sm:text-[15px]" data-id="element-51" data-mp="23993fg94vqki">{faq.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </Container>
    </section>;
}